import * as SecureStore from "@towersystems/roam-common-native/lib/utilities/storage";
import { useContext, useEffect, useState } from "react";
import { defaultLocalSettings, LOCAL_SETTINGS_KEY } from "./constants";
import {
  LocalSettings,
  LocalSettingsContext,
  LocalSettingsContextType,
} from "./context";

export const useLocalSettings = (): LocalSettingsContextType => {
  const [bootstraped, setBootraped] = useState(false);

  const [settings, setSettings] = useState<LocalSettings | undefined>(
    undefined
  );

  useEffect(() => {
    boot().then(() => {
      setBootraped(true);
    });
  }, []);

  const boot = async () => {
    const storedScheme = await SecureStore.getItemAsync(LOCAL_SETTINGS_KEY);
    if (storedScheme) {
      setSettings(JSON.parse(storedScheme));
    } else {
      setSettings(defaultLocalSettings);
    }
  };

  const setSetting = (key: keyof LocalSettings, value: any) => {
    const newSettings = {
      ...defaultLocalSettings,
      ...settings,
      [key]: value,
    };
    SecureStore.storeItemAsync(LOCAL_SETTINGS_KEY, JSON.stringify(newSettings));
    setSettings(newSettings);
  };

  return {
    bootstraped: bootstraped,
    settings: settings ? settings : defaultLocalSettings,
    setSetting,
  };
};

export const useLocalSettingsProvider = () => {
  const context = useContext(LocalSettingsContext);
  if (!context) {
    throw new Error("No LocalSettingsContext context was provided.");
  }
  return context;
};
